export const EXTERNAL_LINK = {
  termsOfConditions: "/docs/terms.pdf",
  privacyPolicy: "/docs/privacy.pdf",
  userAgreement: "/docs/agreement.pdf",
};
